import { BaseIcon } from '../BaseIcon';
import type { BaseIconProps } from '../BaseIcon';

type FolderOpenIconProps = Omit<BaseIconProps, 'children'>;

export const FolderOpenIcon = ({ ...props }: FolderOpenIconProps) => (
  <BaseIcon hasLegacyStrokeStyles={false} width="18" height="14" viewBox="0 0 18 14" fill="none" {...props}>
    <g clipPath="url(#a)">
      <path fill="#141B4D" d="M0 1a1 1 0 0 1 1-1h5a1 1 0 0 1 .707.293l3 3A1 1 0 0 1 9 5H1a1 1 0 0 1-1-1V1Z" />
      <path fill="#141B4D" d="M1 4h13v8a1 1 0 0 1-1 1H2a1 1 0 0 1-1-1V4Z" />
      <path
        fill="#141B4D"
        fillRule="evenodd"
        d="M0 4a1 1 0 0 1 1-1h13a1 1 0 0 1 1 1v8a2 2 0 0 1-2 2H2a2 2 0 0 1-2-2V4Zm2 1v7h11V5H2Z"
        clipRule="evenodd"
      />
      <path fill="#fff" d="M3 4h14l-1.826 8.217a1 1 0 0 1-.976.783H2.246a1 1 0 0 1-.976-1.217L3 4Z" />
      <path
        fill="#141B4D"
        fillRule="evenodd"
        d="M2.024 3.783A1 1 0 0 1 3 3h14a1 1 0 0 1 .976 1.217l-1.826 8.217A2 2 0 0 1 14.198 14H2.247a2 2 0 0 1-1.953-2.434l1.73-7.783ZM3.802 5l-1.555 7h11.95l1.556-7H3.803Z"
        clipRule="evenodd"
      />
    </g>
    <defs>
      <clipPath id="a">
        <path fill="#fff" d="M0 0h18v14H0z" />
      </clipPath>
    </defs>
  </BaseIcon>
);

FolderOpenIcon.displayName = 'FolderOpenIcon';
